import React from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from '@mui/material';

interface PaymentProcessingDialogProps {
  open: boolean;
}

export default function PaymentProcessingDialog({ open }: PaymentProcessingDialogProps) {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundImage: 'none',
          overflow: 'hidden',
        },
      }}
    >
      <DialogContent sx={{ px: { xs: 3, sm: 4 }, py: 4, textAlign: 'center' }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            mx: 'auto',
            mb: 2.5,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            bgcolor: 'rgba(237, 137, 54, 0.12)',
          }}
        >
          <CircularProgress size={42} sx={{ color: '#ed8936' }} />
        </Box>

        <Typography variant="h5" fontWeight={800} sx={{ mb: 1 }}>
          Payment processing
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.65 }}>
          We are confirming your payment. Please keep this page open.
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
